<template>
  <div class="separator">&nbsp;</div>
</template>

<script setup></script>

<style lang="less">
.itinerary {
  .separator {
    display: flex;
    margin-top: 2rem;
    background: @primary;
  }
}
</style>
